import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { user_register } from '../../redux/actions/userAuthActions'
import { USER_REGISTER_RESET } from '../../redux/types'

import project_bg from '../../assets/ww.png'
import '../../styles/modalForm.css'

const Signup = () => {
	const dispatch = useDispatch()

	const userRegister = useSelector((state) => state.userRegister)
	const { loading, userDetail } = userRegister

	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [email, setEmail] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [agree, setAgree] = useState(false)
	const [message, setMessage] = useState(null)
	const [agreeMessage, setAgreeMessage] = useState(null)
	const [confirmMessage, setConfirmMessage] = useState(null)

	const registerSubmitHandler = (e) => {
		e.preventDefault()
		let data = {
			firstName,
			lastName,
			email,
			phoneNumber,
			password,
		}
		if (agree === true) {
			if (password === confirmPassword) {
				dispatch(user_register(data))
				setFirstName('')
				setLastName('')
				setEmail('')
				setPhoneNumber('')
				setPassword('')
				setConfirmPassword('')
				setAgree(false)
			} else {
				setMessage('Passwords do not match')
			}
		} else {
			setAgreeMessage('Please click to accept.')
		}
	}

	useEffect(() => {
		if (userDetail) {
			console.log(userDetail)
			setConfirmMessage(userDetail.message)
		}

		return () => {
			dispatch({ type: USER_REGISTER_RESET })
		}
	}, [dispatch, userDetail])

	const viewHandler2 = () => {
		let pass2 = document.getElementById('password2')
		let view2 = document.getElementById('view2')
		const type2 =
			pass2.getAttribute('type') === 'password' ? 'text' : 'password'
		pass2.setAttribute('type', type2)

		view2.classList.toggle('fa-eye-slash')
	}

	const viewHandler3 = () => {
		let pass3 = document.getElementById('password3')
		let view3 = document.getElementById('view3')
		const type3 =
			pass3.getAttribute('type') === 'password' ? 'text' : 'password'
		pass3.setAttribute('type', type3)

		view3.classList.toggle('fa-eye-slash')
	}

	return (
		<section style={{ background: `url(${project_bg})` }} className='login'>
			<div className='container'>
				<div className='row justify-content-center'>
					<div className='col-lg-5 col-md-9'>
						{confirmMessage && (
							<p
								style={{
									color: 'green',
									marginBottom: '1rem',
									fontSize: '14px',
									textAlign: 'center',
								}}
							>
								<i className='fas fa-check-circle mr-2'></i>
								{confirmMessage}
							</p>
						)}
						<div className='login_form'>
							<h4 className='text-center'>
								{' '}
								<strong> REGISTER </strong>{' '}
							</h4>
							<form className='' onSubmit={registerSubmitHandler}>
								<label className='label'>First name</label>
								<input
									type='text'
									value={firstName}
									required
									className='form-control mb-3'
									onChange={(e) => setFirstName(e.target.value)}
								/>
								<label className='label'>Last name</label>
								<input
									type='text'
									value={lastName}
									required
									className='form-control mb-3'
									onChange={(e) => setLastName(e.target.value)}
								/>
								<label className='label'>Email</label>
								<input
									type='email'
									required
									value={email}
									className='form-control mb-3'
									onChange={(e) => setEmail(e.target.value)}
								/>
								<label className='label'>Phone Number</label>
								<input
									type='text'
									required
									name='phoneNumber'
									value={phoneNumber}
									className='form-control mb-3'
									onChange={(e) => setPhoneNumber(e.target.value)}
								/>
								<label className='label'>Password</label>
								<div style={{ position: 'relative' }}>
									<input
										type='password'
										id='password2'
										required
										name='password'
										value={password}
										className='form-control mb-1'
										onChange={(e) => setPassword(e.target.value)}
									/>
									<i
										className='fa fa-eye view'
										id='view2'
										onClick={viewHandler2}
									></i>
								</div>
								<label className='label'>Confirm Password</label>
								<div style={{ position: 'relative' }}>
									<input
										type='password'
										id='password3'
										required
										value={confirmPassword}
										className='form-control mb-1'
										onChange={(e) => setConfirmPassword(e.target.value)}
									/>
									<i
										className='fa fa-eye view'
										id='view3'
										onClick={viewHandler3}
									></i>
								</div>
								<p
									style={{
										color: '#fc1a29',
										marginTop: '.5rem',
										marginBottom: '1rem',
										fontSize: '12px',
									}}
								>
									{message}
								</p>
								<input
									type='checkbox'
									onChange={(e) => setAgree(!agree)}
									defaultChecked={agree}
								/>{' '}
								<span>I agree to the Terms &amp; Conditions</span>
								<p
									style={{
										color: '#fc1a29',
										marginTop: '-1.5rem',
										fontSize: '12px',
									}}
								>
									{agreeMessage}
								</p>
								<div className='text-center mb-2'>
									<button
										className='form-control modal_btn'
										disabled={
											email &&
											password &&
											firstName &&
											lastName &&
											phoneNumber &&
											!loading
												? false
												: true
										}
									>
										{loading ? (
											<i className='fas fa-spinner fa-spin'></i>
										) : (
											<span className='text-white'>Signup</span>
										)}
									</button>
								</div>
								<p className='reset text-center'>
									Already have an account? <Link to='/login'>Login here</Link>{' '}
								</p>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Signup
